var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiButton from '@material-ui/core/Button';
var MuiButtonComponent = MuiButton;
/**
 * Kareo wrapped component of the Material-UI Button. The prop API has been limited to props defined in ButtonProps.
 *
 * Buttons allow users to take actions and make choices, with a single tap.
 *
 * Material-UI Button: [Docs](https://v4.mui.com/components/buttons/), [API](https://v4.mui.com/api/button/)
 *
 * @storybook: [Button](http://design.kareoprod.ent/design-system/?path=/story/components-inputs-button--button-main-story)
 */
var Button = React.forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    return (React.createElement(MuiButtonComponent, __assign({}, props, { ref: ref, disableFocusRipple: true, disableTouchRipple: true, disableRipple: true })));
});
Button.defaultProps = {
    variant: 'contained',
};
Button.displayName = 'KareoButton';
export default Button;
